import { fetchTimeInterval, getCurrentDate, getCurrentTime, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const Injection = async (props) => {
  const stackedFieldStyle = {
    layout: 'stacked',
    showContainerBorder: false,
    labelWrap: false,
    isLabel: false,
  };

  let charts = [{
    type: 'Grid',
    col: 'col-lg-3',
    data: [{
      type: "PatientDetails",
      employeeDetails: props.employeeDetails,
      visitDetails: props.visitDetails
    }, {
      type: "CompanyDetails",
      companyDetails: props.companyDetails
    }],
  },
  {
    type: 'Tab',
    col: 'col-lg-9',
    data: [
      {
        id: 'injection_details',
        label: 'Medication Administration',
        data: [
          {
            label: "Medication Administration Details",
            labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "NewTextInput",
                label: "Medication Name",
                placeholder: "Enter medication name",
                required: true,
                className: "form-control form-control-solid",
                name: "injection_name",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewDate",
                label: "Administered Date",
                required: true,
                placeholder: "MM / DD / YYYY",
                className: "form-control form-control-solid",
                name: "visit_date",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewSelectSearchList",
                label: "Visit Time",
                placeholder: "Select...",
                isAsync: true,
                options: [{ 'label': getCurrentTime(), value: getCurrentTime() }],
                loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
                className: "form-control form-control-solid",
                name: "visit_time",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewTextInput",
                label: "Reason / Indication",
                placeholder: "Enter reason or indication for administration",
                className: "form-control form-control-solid",
                name: "reason_indication",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewSelectList",
                label: "Route",
                placeholder: "Select...",
                className: "form-control form-control-solid",
                options: [
                  { label: "--Select--", value: "" },
                  { label: "IM (Intramuscular)", value: "IM" },
                  { label: "IV (Intravenous)", value: "IV" },
                  { label: "SubQ (Subcutaneous)", value: "SubQ" },
                  { label: "ID (Intradermal)", value: "ID" },
                  { label: "Other", value: "Other" }
                ],
                name: "route",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewSelectList",
                label: "Administered Site",
                placeholder: "Select...",
                className: "form-control form-control-solid",
                options: [
                  { label: "--Select--", value: "" },
                  { label: "Left Deltoid", value: "Left Deltoid" },
                  { label: "Right Deltoid", value: "Right Deltoid" },
                  { label: "Left Gluteus", value: "Left Gluteus" },
                  { label: "Right Gluteus", value: "Right Gluteus" },
                  { label: "Left Thigh", value: "Left Thigh" },
                  { label: "Right Thigh", value: "Right Thigh" },
                  { label: "Other", value: "Other" }
                ],
                name: "injection_adminstration_site",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewTextInput",
                label: "Lot Number",
                placeholder: "Enter lot number",
                className: "form-control form-control-solid",
                name: "lot_number",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewDate",
                label: "Expiration Date",
                placeholder: "MM / DD / YYYY",
                className: "form-control form-control-solid",
                name: "expiration_date",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
              {
                type: "NewTextInput",
                label: "NDC",
                placeholder: "Enter National Drug Code",
                className: "form-control form-control-solid",
                name: "ndc",
                col: "col-lg-6 col-md-6 col-12 border-0",
              },
            ]
          },
          {
            label: "Review / Completion",
            labelStyle: "fw-semibold",
            fields: [
              {
                type: "ProviderSignOff",
                col: "col-12",
                fields: [
                  { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                  { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                  { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                  // Previous options:
                  // { label: "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started', 'Administered', 'Not Administered']), statusBasedColor: true },
                  // { label: "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started', 'Ordered', 'Ready for Review', 'Completed', 'Cancelled']), statusBasedColor: true },
                  // New standard options:
                  {
                    label: "Final Results",
                    type: "SelectList",
                    name: "status",
                    col: "col-12",
                    options: optionsToKeyValuePairs(
                      [
                        "Not Started",
                        "Pending",
                        "Normal",
                        "Abnormal",
                        "Negative",
                        "Positive",
                        "Dispensed",
                        "Administered",
                        "Failed",
                        "Passed",
                        "Non-Negative",
                        "Cancelled",
                        "Inconclusive",
                      ],
                      false
                    ),
                    statusBasedColor: true,
                  },
                  {
                    label: "Activity Status",
                    type: "SelectList",
                    name: "activity_status",
                    col: "col-12",
                    options: optionsToKeyValuePairs(
                      [
                        "Not Started",
                        "Pending",
                        "Pending Lab Confirmation",
                        "Pending MRO Confirmation",
                        "Ready for Review",
                        "Completed",
                        "Cancelled",
                      ],
                      false
                    ),
                    statusBasedColor: true,
                  },
                ],
              },
            ],
          },
        ]
      },
      {
        id: 'Images',
        label: 'Images',
        data: []
      }
    ]
  },
 
  ];

  // Auto-populate injection_name from EMR field label (selected option when provider clicked Accept/Replace)
  const emrFieldLabel = props.emrFieldLabel || "";
  const defaultValue = {
    visit_date: getCurrentDate(),
    visit_time: getCurrentTime(),
    status: 'Not Started',
    suggested_status: 'Not Started',
    activity_status: 'Not Started',
    injection_name: emrFieldLabel,
  };

  const buttons = {}

  const headers = [{
    type: 'Tab',
    data: [
    
    ]
  }];

  return { 
    buttons, 
    charts, 
    defaultValue, 
    headers, 
    computationFunction: (formData, key) => ({
      ...computationRulesForInjection(formData, key),
      // ...computationRules1(formData, key),
    }),
  };
}
const computationRulesForInjection = (formData, key) => {
  let returnResult = {};
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key==='injection_adminstration_site' && formData.injection_adminstration_site){
    returnResult.status = 'Administered';
  }else if(key==='injection_adminstration_site' && !formData.injection_adminstration_site){
    returnResult.status = 'Pending';
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }

  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }
  return returnResult;
}
const computationRules = (formData, key) => {
  let returnResult = {};
  // if(key==='status' && formData.status==='Not Started' ){
  //   return {
  //     status: 'Not Started',
  //     activity_status: 'Not Started'
  //   };
  // }
  // if(key==='status' && formData.status==='Administered' ){
  //   return {
  //     activity_status: 'Completed'
  //   };
  // }
  
  // Avoid feedback loops when status or activity_status themselves are being changed
  if (key === 'status' || key === 'activity_status') {
    return returnResult;
  }
  
  // Check if any Medication Administration Details fields have values
  const medicationAdminFields = [
    'injection_name',
    'visit_date',
    'visit_time',
    'reason_indication',
    'route',
    'injection_adminstration_site',
    'lot_number',
    'expiration_date',
    'ndc'
  ];
  
  const hasAnyMedicationAdminValue = medicationAdminFields.some(field => {
    const value = formData[field];
    return value !== null && value !== undefined && value !== '';
  });
  
  // If any medication administration detail is entered, auto-update statuses
  if (hasAnyMedicationAdminValue) {
    returnResult.status = 'Administered';
    returnResult.activity_status = 'Completed';
  }
  
  return returnResult;
}
